import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propFunc, propBool, } from '../../../../../../../helpers/custom-prop-types';
import SubmitButton from '../../../../../../Ui/Button/SubmitButton';
const RfpOneDescriptionFileDownload = (props) => {
    const { loading, onClick } = props;
    return (_jsx("div", Object.assign({ className: 'rfp-description-file-download' }, { children: _jsx(SubmitButton, { buttonType: 'button', className: 'download_value', isDisabled: loading, isLoading: loading, onClick: onClick, text: _jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: 'download_text' }, { children: "\u63D0\u6848\u66F8\u30FB\u6DFB\u4ED8\u8CC7\u6599\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9" })), _jsx("i", { className: 'download_icon material-icons get_app link' })] }) }) })));
};
RfpOneDescriptionFileDownload.propTypes = {
    loading: propBool().isRequired,
    onClick: propFunc().isRequired,
};
export default RfpOneDescriptionFileDownload;
